export default "__VITE_ASSET__8241abf0__"